import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class PropertySettingService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PROPERTYSETTING_UPDATE(
          $id: String!
          $data: PropertySettingInput!
        ) {
          propertySettingUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.propertySettingUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PROPERTYSETTING_DESTROY($ids: [String!]!) {
          propertySettingDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.propertySettingDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PROPERTYSETTING_CREATE($data: PropertySettingInput!) {
          propertySettingCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.propertySettingCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PROPERTYSETTING_IMPORT(
          $data: PropertySettingInput!
          $importHash: String!
        ) {
          propertySettingImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.propertySettingImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query PROPERTYSETTING_FIND($id: String!) {
          propertySettingFind(id: $id) {
            id
            logo {
              id
              name
              sizeInBytes
              publicUrl
              privateUrl
            }
            theme
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.propertySettingFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query PROPERTYSETTING_LIST(
          $filter: PropertySettingFilterInput
          $orderBy: PropertySettingOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          propertySettingList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              logo {
                id
                name
                sizeInBytes
                publicUrl
                privateUrl
              }
              theme
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.propertySettingList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query PROPERTYSETTING_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          propertySettingAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.propertySettingAutocomplete;
  }
}
